<script setup lang="ts">
import Joi from 'joi'
import type { FormErrorEvent } from '#ui/types'
import type { Client } from "~/common/types/types";
import EditClient from './EditClient.vue';
import { isEntityId } from '../util';

const schema = Joi.object({
  _id: Joi.custom(isEntityId),
  name: Joi.string().required(),
  orgId: Joi.custom(isEntityId),
  created: Joi.date().required(),
})

const client = defineModel({
  required: true,
  type: Object as PropType<Client>   
})

const emit = defineEmits(['submitted'])

async function onSubmit () {
  emit('submitted', {
    ...client.value, 
  });
}

async function onError (event: FormErrorEvent) {
  console.log(event.errors)
}

</script>

<template>
  <UForm :schema="schema" :state="client" class="space-y-4" @submit="onSubmit" @error="onError" >
    <EditClient v-model="client" />    
    <UButton type="submit" class="mt-3">
      Update Client
    </UButton>
  </UForm>    
</template>